// extracted by mini-css-extract-plugin
module.exports = {"navItemActive":"recent-posts-module--nav-item-active--3KnSx"};